import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, useResponsive } from '@common-fe/common-fe';

import { useInvestor } from '../hooks';
import { InvestorStatus } from '../investments.types';
import { useInvestmentsStartQuery } from '../queries';

interface Props {
  accountId?: string;
  isWideMode?: boolean;
}
const InvestmentResumeBlock: React.FC<Props> = ({ accountId, isWideMode }) => {
  const { data: investor, isOnlyOneInvestmentPath } = useInvestor();
  const { t } = useTranslation();
  const { handleSave: handleStartInvestments, handleRedirectToStart } = useInvestmentsStartQuery({
    accountId: accountId,
  });

  const { isMobile } = useResponsive();
  if (!investor.type || investor.status === InvestorStatus.INVESTOR_CREATED) {
    return null;
  }

  if (isMobile) {
    return (
      <Box direction="column" margin={{ top: 'm' }} gap="spacing12">
        <AppButton
          fill
          onClick={(e) => {
            e.stopPropagation();
            handleStartInvestments();
          }}
        >
          {t('Resume Investing')}
        </AppButton>

        <AppButton
          fill
          onClick={(e) => {
            e.stopPropagation();
            handleRedirectToStart(investor.investorId, true);
          }}
          buttonType="secondary"
        >
          {isOnlyOneInvestmentPath ? t('Invest With Another Model') : t('Invest With Another Model')}
        </AppButton>
      </Box>
    );
  }
  return (
    <Box direction="column" margin={{ top: 'm' }}>
      <Box direction={isWideMode ? 'row-reverse' : 'row'}>
        <div>
          <AppButton
            width="220px"
            onClick={(e) => {
              e.stopPropagation();
              handleStartInvestments();
            }}
          >
            {t('Resume Investing')}
          </AppButton>
        </div>
        <Box margin={{ left: 's' }}></Box>
        <div>
          <AppButton
            onClick={(e) => {
              e.stopPropagation();
              handleRedirectToStart(investor.investorId, true);
            }}
            width="220px"
            buttonType="secondary"
          >
            {isOnlyOneInvestmentPath ? t('Restart Investing') : t('Invest With Another Model')}
          </AppButton>
        </div>
      </Box>
    </Box>
  );
};
export default React.memo(InvestmentResumeBlock);
